import axios from "axios";

const API = axios.create({
  baseURL: "https://api.scoriva.net/api", // portunu düz yaz
});

export const orderApi = {
  getAll: () => API.get("/orders"),
  updateStatus: (id, status) => API.put(`/orders/${id}/status`, { status }),
  remove: (id) => API.delete(`/orders/${id}`),
};
